import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppConfig } from 'src/app/app.config';

@UntilDestroy()
@Injectable()
export class FeatureToggleService {


  constructor(private appConfig: AppConfig) { 

  }

  private featureOff(featureName: string): boolean {
    const feature = this.appConfig.getSection(featureName);
    return feature ? !feature.enabled : true;
  }
  
  public featureOn(featureName: string): boolean {
    return !this.featureOff(featureName);
  }

  private featureIndividualInvestorOff(featureName: string): boolean {
    const feature = this.appConfig.getSection(featureName);
    const allowIndividualInvestorSettingExist = feature?.hasOwnProperty('allowInvestor');
    // check to see if 'allowInvestor' property exists, if so, check if 'allowInvestor' is set to true. 
    // If 'allowInvestor' property doesn't exist, general feature property 'enabled' is applied to all users
    return allowIndividualInvestorSettingExist ? !feature.allowInvestor : this.featureOff(featureName);
  }

  public featureIndividualInvestorOn(featureName: string): boolean {
    return !this.featureIndividualInvestorOff(featureName);
  }
}